import { HotelCategoryKey } from '../types/HotelCategoryKey';

export const HOTEL_CATEGORY_ICONS = {
    STAR_FULL: 'material-symbols:star',
    STAR_HALF: 'material-symbols:star-half',
    STAR_EMPTY: 'material-symbols:star-outline',
    KEY_FULL: 'material-symbols:key',
    KEY_EMPTY: 'material-symbols:key-outline',
    APARTMENT: 'material-symbols:apartment',
    HOTEL: 'material-symbols:domain',
} as const;

export type CategoryIconSet =
    | { type: 'stars'; full: number; half: boolean; empty: number }
    | { type: 'keys'; full: number; empty: number }
    | { type: 'apartment' }
    | null;

const MAX_STARS = 6;
const MAX_KEYS = 5;

const STAR_VALUES: Record<string, number> = {
    [HotelCategoryKey.ONE_STAR]: 1,
    [HotelCategoryKey.TWO_STARS]: 2,
    [HotelCategoryKey.THREE_STARS]: 3,
    [HotelCategoryKey.FOUR_STARS]: 4,
    [HotelCategoryKey.FIVE_STARS]: 5,
    [HotelCategoryKey.SIX_STARS]: 6,
    [HotelCategoryKey.TWO_HALF_STARS]: 2.5,
    [HotelCategoryKey.THREE_HALF_STARS]: 3.5,
};

const KEY_VALUES: Record<string, number> = {
    [HotelCategoryKey.ONE_KEY]: 1,
    [HotelCategoryKey.TWO_KEYS]: 2,
    [HotelCategoryKey.THREE_KEYS]: 3,
    [HotelCategoryKey.FOUR_KEYS]: 4,
    [HotelCategoryKey.FIVE_KEYS]: 5,
};

export const getHotelCategoryIcons = (key: string): CategoryIconSet => {
    if (key === HotelCategoryKey.APARTMENT) {
        return { type: 'apartment' };
    }

    if (key in STAR_VALUES) {
        const value = STAR_VALUES[key];
        const full = Math.floor(value);
        const half = value % 1 !== 0;
        const empty = MAX_STARS - full - (half ? 1 : 0);
        return { type: 'stars', full, half, empty };
    }

    if (key in KEY_VALUES) {
        const full = KEY_VALUES[key];
        return { type: 'keys', full, empty: MAX_KEYS - full };
    }

    return null;
};
